import React from 'react'
import { BillingRoot } from '@/features/billing/routes'
import { ChatsRoot } from '@/features/chat/routes'
import { Dashboard } from '@/features/dashboard/routes'
import { ProfileRoot } from '@/features/profile/routes'
import { ROLE } from '@/features/users/types'
import { GUARD } from '../../guards'

type PrivateRouteType = {
  index?: boolean
  path?: string
  element: React.ReactNode
  roles?: Array<string>
  guards: Array<GUARD>
}

const generalRoutes: PrivateRouteType[] = [
  {
    path: 'profile/*',
    element: <ProfileRoot />,
    roles: [ROLE.Client],
    guards: [],
  },
  {
    path: 'dashboard',
    element: <Dashboard />,
    roles: [ROLE.Client],
    guards: [],
  },
  {
    path: 'chats/*',
    element: <ChatsRoot />,
    roles: [ROLE.Client],
    guards: [],
  },
  {
    path: 'billing/*',
    element: <BillingRoot />,
    roles: [ROLE.Client],
    guards: [],
  },
]

export const getGeneralRoutes = () => {
  return generalRoutes
}
